export default __webpack_public_path__ + "coinholio.smart.design.2604ce881284b50a0bc53a6f2d79331e.png";